import { useEffect, useState } from "react";
import { wfAPI } from "./wfApi";
import { toast } from "sonner";
import { ScrollText } from "lucide-react";

export default function Audit() {
  const [items, setItems] = useState([]);

  useEffect(() => { wfAPI.audit(200).then(setItems).catch((e) => toast.error(e?.response?.data?.detail || "Failed")); }, []);

  return (
    <div className="space-y-4" data-testid="wf-audit">
      <div>
        <h2 className="font-display text-[18px] font-semibold text-hocp-navy">Workforce Audit Log</h2>
        <p className="text-[12.5px] text-slate-500">Append-only. Every action mutating identity, role or permission generates an audit line.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        {items.length === 0 ? (
          <div className="p-10 text-center text-slate-400 text-[13px]">No events yet.</div>
        ) : items.map((a) => (
          <div key={a.id} data-testid={`audit-${a.id}`} className="grid grid-cols-[1fr_1.5fr_1fr_2fr] gap-4 px-5 py-3 border-b border-slate-100 last:border-0 text-[12.5px] items-center">
            <div className="flex items-center gap-2 min-w-0">
              <ScrollText className="w-3.5 h-3.5 text-slate-400 shrink-0"/>
              <span className="mono text-slate-700 truncate">{a.action}</span>
            </div>
            <div className="text-slate-600 truncate">{a.actor_email}</div>
            <div className="text-slate-500 truncate">{a.entity_type}</div>
            <div className="text-[11px] text-slate-400 tabular-nums">{a.created_at}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
